import { render, staticRenderFns } from "./InfoComponent.vue?vue&type=template&id=533869df&scoped=true"
import script from "./InfoComponent.vue?vue&type=script&lang=js"
export * from "./InfoComponent.vue?vue&type=script&lang=js"
import style0 from "./InfoComponent.vue?vue&type=style&index=0&id=533869df&prod&lang=scss&scoped=true"
import style1 from "./InfoComponent.vue?vue&type=style&index=1&id=533869df&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533869df",
  null
  
)

export default component.exports